import Swal from "sweetalert2";
import {useEffect, useState} from "react"
import {FaPlus} from "react-icons/fa";
import {Template} from "../../../../components/template/template";
import Button from "../../../../components/button/button";
import {Card} from "../../../../components/card/card";
import InputForm from "../../../../components/input/input-form";
import {useRuleData} from "../components/use-rule-data";
import SelectComponent from "../../../../components/select/select-component";
import DeviceList from "../components/device-list";
import ModalAddDevice from "../components/modal-add-device";
import ModalRemoveDevice from "../components/modal-remove-device";
import ProjectUtils from "../../../../utils/project-utils";
import projectUtils from "../../../../utils/project-utils";
import {navigateHook} from "../../../../hooks/use-navigate";
import {useParams} from "react-router";
import ruleService from "../../../../services/web/rule-service";


const RuleForm = ({ id, idCopy }) => {
    const navigate = navigateHook();
    const [btnLoading, setBtnLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [showAddDevice, setShowAddDevice] = useState(false);
    const [showRemoveDevice, setShowRemoveDevice] = useState(false);

    const [name, setName] = useState("");
    const [visibility, setVisibility] = useState("");
    const [type, setType] = useState("");
    const [reasons, setReasons] = useState([]);
    const [lanes, setLanes] = useState([]);
    const [dow, setDow] = useState([]);
    const [periodIni, setPeriodIni] = useState(0);
    const [periodEnd, setPeriodEnd] = useState(0);
    const [devices, setDevices] = useState([]);

    const { id: routeParam} = useParams();
    const effectiveId = routeParam ?? id ?? idCopy ?? null;
    const [currentId, setCurrentId] = useState( effectiveId ? Number(effectiveId) : null );
    const ruleId = currentId;
    const {
        visibilityOptions, typeOptions, reasonOptions, laneOptions, dowOptions, devicesFetched, isAnyLoading, initialRule, refetch,
    } = useRuleData(ruleId);
    const loader = isAnyLoading;

    useEffect(() => {
        const newEffectiveId = routeParam ?? id ?? idCopy ?? null;
        setCurrentId(newEffectiveId ? Number(newEffectiveId) : null);
    }, [routeParam, id, idCopy]);

    useEffect(() => {
       setDevices(Array.isArray(devicesFetched) ? devicesFetched : []);
    }, [devicesFetched]);

    useEffect(() => {
        if(!initialRule) return;

        const f = initialRule.filters ?? {};

        setName(initialRule.name ?? "");
        setVisibility(
            initialRule.visibilityRoleId != null ? String(initialRule.visibilityRoleId) : ""
        );
        setType(f.type ?? "");

        if(f.type === "extern") {
            setReasons([]);
        } else {
            const reasonNames = Array.isArray(f.reason) ? f.reason.map(String) : [];

            const selectedIds =
                reasonOptions 
                    ?.filter(opt => 
                        reasonNames.includes(opt.label) ||
                        reasonNames.includes(String(opt.value))
                    )
                    .map(opt => String(opt.value))

            setReasons(selectedIds);
        }

        setLanes(f.lanes ?? []);
        setDow(f.dow ?? []);
        setPeriodIni(f.period_ini ?? 0);
        setPeriodEnd(f.period_end ?? 0);

    }, [initialRule, reasonOptions]);

    const validate = () => {
        if(!name?.trim()) return 'O campo "Nome" é obrigatório.';
        if(!visibility) return 'O campo "Visível para a função" é obrigatório.';
        if(!type) return 'O campo "Tipo de monitoramento" é obrigatório.';
        if(type !== 'extern' && (!reasons?.length)) return 'O campo "Naturezas" é obrigatório.';
        if(!lanes?.length) return 'O campo "Câmeras" é obrigatório.';
        if(!dow?.length) return 'O campo "Dias da semana" é obrigatório.';
        return null; 
    };

    const normalizeToIdArray = (arr) => (arr ?? [])
            .map((item) => {
                if (item && typeof item === "object") {
                    return item.id ? Number(item.id) : null;
                }
                return Number(item);
            })
            .filter((val) => Number.isFinite(val) && val > 0);

    const handleSave = () => {
        setIsSaving(true);
        const err = validate();
        if(err) {ProjectUtils.swalErrorMessage('', err, 'Ok'); setIsSaving(false); return;}
        
        setBtnLoading(true);
    
        const payload = {
            name,
            visibility: Number(visibility),
            monitoringType: type,
            reasons: normalizeToIdArray(reasons),
            lanes: normalizeToIdArray(lanes),
            devices: normalizeToIdArray(devices),
            daysOfTheWeek: normalizeToIdArray(dow),
            fromHour: Number(periodIni) || 0,
            toHour: Number(periodEnd) || 0,
        };

        const request = currentId
            ? ruleService.update(currentId, payload)
            : ruleService.create(payload);

        request.then((response) => {
            setBtnLoading(false);

            const data = response;
            const newId = data?.id ?? currentId;

            projectUtils.success(!currentId);
            setCurrentId(newId);

            if (currentId) {
                refetch?.();
                return;
            }
        
            const urlDev = `/rule-form/${newId}`;
            navigate(urlDev);
        })
        .catch((error) => {
            console.error(error);
            let message = "Não foi possível salvar."

        if(error.response?.data) {
            message = error.response.data.message || error.response.data.error || message;
        }

            ProjectUtils.swalErrorMessage("", message, "Ok");
            setBtnLoading(false);
        })
        .finally(() => {
            setIsSaving(false);
        })
    };

    const handleDelete = () => {
        if (!currentId) return;

        Swal.fire({
            title: "Excluir",
            text: `Excluir a regra de alarme "${name}"?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#063A6C",
            confirmButtonText: "Sim",
            cancelButtonColor: "#c10007",
            cancelButtonText: "Não",
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                return ruleService
                    .remove(currentId)
                    .then(() => {
                        projectUtils.success(true, "Excluído com sucesso");
                        const urlDev = `/rule`;
                        navigate(urlDev);
                    })
                    .catch(() => {
                        ProjectUtils.swalErrorMessage("", "Erro ao excluir.", "ok");
                    });
            }
        });
    };

    const resetForm = () => {
        setName("");
        setVisibility(null);
        setType(null);
        setReasons([]);
        setLanes([]);
        setDow([]);
        setPeriodIni(0);
        setPeriodEnd(0);
        setDevices([]);
    }

    const newRule = () => {
        setCurrentId(null);
        resetForm();

        const urlDev = "/rule-form";
        navigate(urlDev);
    }

    return (
        <Template isLoading={loader || isSaving}>
            <Template.Header>
                <Template.Title>Regra de alarme</Template.Title>
                {currentId && (
                    <Button
                        onClick={newRule}
                        target="primary-outline"
                    >
                        <FaPlus /> Adicionar regra
                    </Button>
                )}
            </Template.Header>
            <Template.Body className="space-y-2">
                <Card>
                    <Card.Body>
                        <div className="flex">
                            <InputForm
                                label='Nome *'
                                id="name"
                                type="text"
                                classNameWrapper="flex-1"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                    </Card.Body>
                </Card>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-2 items-stretch">
                    <div className="flex flex-col gap-2 h-full">
                        <Card className="h-[calc(100vh-193px)] flex flex-col">
                            <Card.Header>
                                <Card.Title>Configurações</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <div className="flex flex-col space-y-4">
                                    <SelectComponent
                                        id="visibility"
                                        label="Visível para a função *"
                                        value={visibilityOptions.find(o => o.value === String(visibility)) ?? null}
                                        options={visibilityOptions}
                                        onChange={(opt) => setVisibility(opt?.value ?? "")}
                                    />
                                    <SelectComponent
                                        id="type"
                                        label="Tipo de monitoramento *"
                                        value={typeOptions.find(o => o.value === String(type)) ?? null}
                                        options={typeOptions}
                                        onChange={(opt) => setType(opt?.value ?? "")}
                                    />
                                    {(type !== "extern") && (
                                        <SelectComponent
                                            id="reason"
                                            label="Naturezas *"
                                            isMulti
                                            value={reasonOptions.filter(o => (reasons ?? []).map(String).includes(o.value))}
                                            options={reasonOptions}
                                            onChange={(arr) => setReasons((arr ?? []).map(o => o.value))}
                                        />
                                    )}
                                    <SelectComponent
                                        id="lane"
                                        label="Câmeras *"
                                        isMulti
                                        value={laneOptions.filter(o => (lanes ?? []).map(String).includes(o.value))}
                                        options={laneOptions}
                                        onChange={(arr) => setLanes((arr ?? []).map(o => o.value))}
                                    />
                                    <SelectComponent
                                        id="dow"
                                        label="Dias da semana *"
                                        isMulti
                                        value={dowOptions.filter(o => (dow ?? []).map(String).includes(o.value))}
                                        options={dowOptions}
                                        onChange={(arr) => setDow((arr ?? []).map(o => o.value))}
                                    />
                                    <div className="flex gap-4">
                                        <InputForm
                                            label="Horário inicial"
                                            type="number"
                                            classNameWrapper="flex-1"
                                            min={0}
                                            max={23}
                                            value={periodIni}
                                            className={'active'}
                                            onChange={(e) => {
                                                const val = Math.max(0, Math.min(23, Number(e.target.value)));
                                                setPeriodIni(val);
                                            }}
                                        />
                                        <InputForm
                                            label="Horário final"
                                            type="number"
                                            classNameWrapper="flex-1"
                                            min={0}
                                            max={23}
                                            value={periodEnd}
                                            className={'active'}
                                            onChange={(e) => {
                                                const val = Math.max(0, Math.min(23, Number(e.target.value)));
                                                setPeriodEnd(val);
                                            }}
                                        />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className="flex flex-col gap-2 h-full">
                        <Card className="h-[calc(100vh-193px)] flex flex-col">
                            <Card.Header>
                                <Card.Title>Dispositivos</Card.Title>
                            </Card.Header>
                            <Card.Body className="flex flex-col flex-1 min-h-0">
                                <div className="flex-1 min-h-0 overflow-auto">
                                    <DeviceList
                                        devices={devices}
                                        onAddClick={() => setShowAddDevice(true)}
                                        onRemoveClick={() => setShowRemoveDevice(true)}
                                    />
                                </div>
                                <div className="mt-auto flex w-full justify-end gap-2 pt-2">
                                    <Button target="danger" onClick={() => setShowRemoveDevice(true)}>Remover dispositivo</Button>
                                    <Button onClick={() => setShowAddDevice(true)}>Adicionar dispositivo</Button>
                                </div>
                                <ModalAddDevice
                                    show={showAddDevice}
                                    onClose={() => setShowAddDevice(false)}
                                    existingDevices={devices}
                                    onConfirm={(newDevices) =>
                                        setDevices((prev) => [
                                            ...prev,
                                            ...newDevices.filter((d) => !prev.some((p) => p.id === d.id))
                                        ])
                                    }
                                />
                                <ModalRemoveDevice
                                    show={showRemoveDevice}
                                    onClose={() => setShowRemoveDevice(false)}
                                    existingDevices={devices}
                                    onConfirm={(toRemove) =>
                                        setDevices((prev) =>
                                            prev.filter((d) => !toRemove.some((r) => r.id === d.id))
                                        )}
                                />
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <Card>
                    <Card.Body>
                        <div className="flex gap-2 justify-end">
                            {currentId && (
                                <Button onClick={handleDelete} target="danger" actionFeedbackType='delete'>Excluir</Button>
                            )}
                            <Button onClick={handleSave} disabled={isSaving || loader}  actionFeedbackType='save'> Salvar</Button>
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
}

export default RuleForm;